import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Popconfirm,
  Space,
  Card,
  Tag,
} from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../services/api';

const Aseguradoras = () => {
  const [aseguradoras, setAseguradoras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingAseguradora, setEditingAseguradora] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchAseguradoras();
  }, []);

  const fetchAseguradoras = async () => {
    setLoading(true);
    try {
      const response = await api.get('/aseguradoras');
      setAseguradoras(response.data);
    } catch (error) {
      message.error('Error al cargar aseguradoras');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingAseguradora) {
        await api.put(`/aseguradoras/${editingAseguradora.id}`, values);
        message.success('Aseguradora actualizada exitosamente');
      } else {
        await api.post('/aseguradoras', values);
        message.success('Aseguradora creada exitosamente');
      }
      setModalVisible(false);
      form.resetFields();
      setEditingAseguradora(null);
      fetchAseguradoras();
    } catch (error) {
      message.error('Error al guardar aseguradora');
    }
  };

  const handleEdit = (record) => {
    setEditingAseguradora(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/aseguradoras/${id}`);
      message.success('Aseguradora eliminada exitosamente');
      fetchAseguradoras();
    } catch (error) {
      message.error('Error al eliminar aseguradora');
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'RUC',
      dataIndex: 'ruc',
      key: 'ruc',
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      key: 'telefono',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Contacto',
      dataIndex: 'contacto',
      key: 'contacto',
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      render: (estado) => {
        const colors = {
          activa: 'green',
          inactiva: 'red',
        };
        return <Tag color={colors[estado]}>{estado.toUpperCase()}</Tag>;
      },
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta aseguradora?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Card
        title="Gestión de Aseguradoras"
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingAseguradora(null);
              form.resetFields();
              setModalVisible(true);
            }}
          >
            Nueva Aseguradora
          </Button>
        }
      >
        <Table
          columns={columns}
          dataSource={aseguradoras}
          rowKey="id"
          loading={loading}
        />
      </Card>

      <Modal
        title={editingAseguradora ? 'Editar Aseguradora' : 'Nueva Aseguradora'}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
          setEditingAseguradora(null);
        }}
        footer={null}
        width={600}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="nombre"
            label="Nombre"
            rules={[{ required: true, message: 'Ingresa el nombre de la aseguradora' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="ruc" label="RUC">
            <Input />
          </Form.Item>
          <Form.Item name="direccion" label="Dirección">
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item name="telefono" label="Teléfono">
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ type: 'email', message: 'Email inválido' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="contacto" label="Contacto">
            <Input />
          </Form.Item>
          <Form.Item name="estado" label="Estado" initialValue="activa">
            <Select>
              <Select.Option value="activa">Activa</Select.Option>
              <Select.Option value="inactiva">Inactiva</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {editingAseguradora ? 'Actualizar' : 'Crear'}
              </Button>
              <Button
                onClick={() => {
                  setModalVisible(false);
                  form.resetFields();
                  setEditingAseguradora(null);
                }}
              >
                Cancelar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Aseguradoras;

